import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_5mmmydek8t: FaireBrandEntity = {
  token: "b_5mmmydek8t",
  type: "brand",
  name: "Ancestral Solskin",
  avatarUrl:
    "https://cdn.faire.com/fastly/19717b4663977db9f8e2ae05e295e8ec0537148957b2ce989971704aae3c5272.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/14982c58577963f61988adb5e2c038530e81ca3153b561c459ab92a7c411ffc4.png",
  logoUrl:
    "https://cdn.faire.com/fastly/19717b4663977db9f8e2ae05e295e8ec0537148957b2ce989971704aae3c5272.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/14982c58577963f61988adb5e2c038530e81ca3153b561c459ab92a7c411ffc4.png",
  location: "Gilbert, AZ, USA",
  minimumOrderDollars: 55,
  rating: 5,
  reviewCount: 5,
  isTopShop: true,
  isInsider: true,
  description:
    "Ancestral Solskin is a desert inspired natural skincare and wellness brand. Our mission is to redefine the skincare and beauty industry using sustainable and locally sourced ingredients.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:44:32.927Z",
    importedBy: "entity-db-cli",
  },
};
